// Author liang gang qiang
// Date 2023-12-13 10:13:13

class JscConfiguration {
constructor({
        id = null,
        moduleCode = '',
        identifyCode = '',
        key = '',
        title = '',
        description = '',
        configuration = '',
        owner = '',
        lastModifyTime = '',
        shareLevel = '',
        remark = ''}
= {}) {
    this.id = id;
    this.moduleCode = moduleCode;
    this.identifyCode = identifyCode;
    this.key = key;
    this.title = title;
    this.description = description;
    this.configuration = configuration;
    this.owner = owner;
    this.lastModifyTime = lastModifyTime;
    this.shareLevel = shareLevel;
    this.remark = remark;
}
}

function newEntity() {
    return new JscConfiguration();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
            label: 'label.em.jsc.jscConfiguration.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'moduleCode',
            label: 'label.em.jsc.jscConfiguration.grid.moduleCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'identifyCode',
            label: 'label.em.jsc.jscConfiguration.grid.identifyCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'key',
            label: 'label.em.jsc.jscConfiguration.grid.key',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'title',
            label: 'label.em.jsc.jscConfiguration.grid.title',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'description',
            label: 'label.em.jsc.jscConfiguration.grid.description',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'configuration',
            label: 'label.em.jsc.jscConfiguration.grid.configuration',
        sortable: true,
        form: {
        type: 'json',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'owner',
            label: 'label.em.jsc.jscConfiguration.grid.owner',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'lastModifyTime',
            label: 'label.em.jsc.jscConfiguration.grid.lastModifyTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'shareLevel',
            label: 'label.em.jsc.jscConfiguration.grid.shareLevel',
        sortable: true,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
        ,options: [
                { value: '1', text: '私有' },
                            { value: '2', text: '配置的' },
                            { value: '15', text: '模块共享' },
                            { value: '20', text: '全局共享' }
            ]
                }
        },
        {
        key: 'remark',
            label: 'label.em.jsc.jscConfiguration.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    moduleCodeFilter : '',
    identifyCodeFilter : '',
    keyFilter : '',
    titleFilter : '',
    descriptionFilter : '',
    configurationFilter : '',
    ownerFilter : '',
    lastModifyTimeRteFilter : '',
    lastModifyTimeLteFilter : '',
    shareLevelFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'moduleCodeFilter',
            label: 'label.em.jsc.jscConfiguration.filter.moduleCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'identifyCodeFilter',
            label: 'label.em.jsc.jscConfiguration.filter.identifyCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'keyFilter',
            label: 'label.em.jsc.jscConfiguration.filter.key',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'titleFilter',
            label: 'label.em.jsc.jscConfiguration.filter.title',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'descriptionFilter',
            label: 'label.em.jsc.jscConfiguration.filter.description',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'configurationFilter',
            label: 'label.em.jsc.jscConfiguration.filter.configuration',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'ownerFilter',
            label: 'label.em.jsc.jscConfiguration.filter.owner',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'lastModifyTimeRteFilter',
            label: 'label.em.jsc.jscConfiguration.filter.lastModifyTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'lastModifyTimeLteFilter',
            label: 'label.em.jsc.jscConfiguration.filter.lastModifyTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'shareLevelFilter',
            label: 'label.em.jsc.jscConfiguration.filter.shareLevel',
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '私有' },
                { value: '2', text: '配置的' },
                { value: '15', text: '模块共享' },
                { value: '20', text: '全局共享' }
            ]
        }
        }
];


    const entityFormConfigs = [
        {
        key: 'moduleCode',
            label: 'label.em.jsc.jscConfiguration.entity.moduleCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'identifyCode',
            label: 'label.em.jsc.jscConfiguration.entity.identifyCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'key',
            label: 'label.em.jsc.jscConfiguration.entity.key',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'title',
            label: 'label.em.jsc.jscConfiguration.entity.title',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'description',
            label: 'label.em.jsc.jscConfiguration.entity.description',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'configuration',
            label: 'label.em.jsc.jscConfiguration.entity.configuration',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'owner',
            label: 'label.em.jsc.jscConfiguration.entity.owner',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'lastModifyTime',
            label: 'label.em.jsc.jscConfiguration.entity.lastModifyTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
            label: 'label.em.jsc.jscConfiguration.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        }
]

export {
    JscConfiguration, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
